export function isWindows() {
  return navigator.platform.indexOf('Win') > -1;
}
